<template>
  <div>
    <pack-info :showMenu="true"></pack-info>
    <v-container>
      <v-row column class="och-topMargin--packInfoOffset">
        <v-col class="dashboard" sm="12">
          <dashboard-service-area :selectedPackId="$route.params.packId" :serviceArea="$route.params.serviceArea">
          </dashboard-service-area>
        </v-col>
        <v-col sm="12">
          <dashboard-user></dashboard-user>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DashboardServiceArea from "@/components/dashboardServiceArea";
import PackInfo from "@/components/packInfo";

import DashboardUser from "./user/DashboardUser";

export default {
  name: "dashboard",
  components: {
    DashboardServiceArea,
    DashboardUser,
    PackInfo,
  },
  computed: {
    packList() {
      return this.$store.state.pack.packList;
    },
  },
  mounted() {
    this.$store.dispatch("pack/getList");
  },
};
</script>
